window.FastClick = require('fastclick');
require('lazyload');

window.notie = require('corner-notie');
window.APlayer = require('aplayer');
window.DPlayer = require('dplayer');

require('./utils');
require('./motion');
require('./affix');
require('./pisces')();
require('./scrollspy');
require('./post-details')();
require('./bootstrap');
require('./evanyou');
require('./leancloud')();
require('./share')();
require('./scroll');
require('./since');
require('./title');
require('./type');
// require('./kanban');
require('./mix');
require('./clipboard');
require('./pjax');
require('./search');
require('./zoom')();
require('./cursor-effects');
